export const apiUrl = 'http://localhost:3000';
export const wsUrl = 'ws://localhost:3000/ws';
